const formattedConstantName = (name) => {
  return name
    .toUpperCase()
    .normalize('NFD')
    .replace(/\p{Mn}/gu, '')
}

export default formattedConstantName
